import {
  DotsThreeVertical,
  PencilSimpleLine,
  Trash,
} from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";

type Action = "edit" | "delete";

interface WebhookActionsDropdownProps {
  openActionModal: (action: Action) => void;
}

export default function ProxyActionsDropdown({
  openActionModal,
}: WebhookActionsDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          intent="iconOnly"
          variant="secondary-black"
          size="sm"
          onClick={(e) => e.stopPropagation()}
        >
          <DotsThreeVertical />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent onClick={(e) => e.stopPropagation()} align="end">
        <DropdownMenuList>
          <DropdownMenuItem onClick={() => openActionModal("edit")}>
            <PencilSimpleLine size={20} />
            Edit
          </DropdownMenuItem>
          <DropdownMenuItem
            variant="danger"
            onClick={() => openActionModal("delete")}
          >
            <Trash />
            Delete
          </DropdownMenuItem>
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
